import { Loader as LoaderStyled } from "./Loader.styled";

const Loader = () => {
  return (
    <LoaderStyled>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
    </LoaderStyled>
  );
};

export default Loader;
